var map = {
	"./admin.js": "dcc39",
	"./auth.js": "11c0",
	"./boothsProject.js": "cd72",
	"./governmentLoansEmployee.js": "9e65",
	"./governmentLoansInjury.js": "422d",
	"./governmentLoansMartyr.js": "eec9",
	"./healthCardMartyr.js": "a62e",
	"./housingUnitsEmployee.js": "2fcc",
	"./housingUnitsInjury.js": "c54b",
	"./housingUnitsMartyr.js": "3005",
	"./layout.js": "c21a",
	"./log.js": "4ed2",
	"./mubinBeneficiary.js": "e43d",
	"./notification.js": "2208",
	"./pankLoansInjury.js": "45bc",
	"./pankLoansMartyr.js": "6daa",
	"./pilgrimageSacrificer.js": "8028",
	"./plotsOfLand2Employee.js": "f48d",
	"./plotsOfLand2Injury.js": "42db",
	"./plotsOfLand2Martyr.js": "1cb7",
	"./plotsOfLandInjury.js": "3aa2",
	"./plotsOfLandMartyr.js": "d0e1",
	"./scholarshipsStudent.js": "e7a7",
	"./ststistic.js": "fc5d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cfa9";